/* eslint-disable require-jsdoc */
import React from 'react';
import Genre from './Genre';
import Day from './Day';
import Sort from './Sort';
import SearchField from 'react-search-field';

import PropTypes from 'prop-types';


export const GenreContext = React.createContext();


const MainFilterPanel = (props) => {
  const {
    onUserGenreInputChange,
    onUserSortInputChange,
    onUserDayInputChange,
    onUserSearchInputChange} = props;

  return (
    <div className="hearby-carousel-controls">
      { props.menuOpts.genre ?
      <Genre change={(result) => {
        onUserGenreInputChange(result.target.value);
      }
      }
      defaultGenreValue={props.defaultGenreValue}
      />
      : null   }
      { props.menuOpts.timeFrame ?
      <Day change={(result) => {
        onUserDayInputChange(result.target.value);
      }
      }
      defaultDayValue={props.defaultDayValue}
      />
      : null   }
      { props.menuOpts.sort ?
      <Sort change={(result) => {
        onUserSortInputChange(result.target.value);
      }
      }
      defaultSortValue={props.defaultSortValue}
      />
      : null   }
      { props.menuOpts.search ?
      <SearchField
        id="hearby-genre-search-input"
        placeholder='Search Shows..'
        onEnter={(result) => {
          onUserSearchInputChange(result);
        }}

        onSearchClick={(result) => {
          onUserSearchInputChange(result);
        }

        }
        className="hearby-carousel-controls-item hearby-hearby-cci-search
                   hearby-search-input"
        classNames="hearby-search-input" />
        : null   }

    </div>
  );
};

MainFilterPanel.propTypes = {
  menuOpts: PropTypes.object.isRequired,
  chosenGenre: PropTypes.string.isRequired,
  onUserGenreInputChange: PropTypes.func.isRequired,
  onUserSortInputChange: PropTypes.func.isRequired,
  chosenSort: PropTypes.string.isRequired,
  onUserDayInputChange: PropTypes.func.isRequired,
  chosenDay: PropTypes.string.isRequired,
  onUserSearchInputChange: PropTypes.func.isRequired,
  defaultGenreValue: PropTypes.string.isRequired,
  defaultSortValue: PropTypes.string.isRequired,
  defaultDayValue: PropTypes.string.isRequired,
};


export default MainFilterPanel;

